import React from 'react';
import { Container } from './styles';

const Error404: React.FC = () => (
  <Container>
    <article>
      <h1>Página não Encontrada! 404</h1>
      <p>Sinto muito, mas a página que está procurando não existe!</p>
    </article>
  </Container>
);

export default Error404;
